import React from 'react';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { scssVariables as variables, lang } from 'src/helpers';

export default class PreviewLink extends React.PureComponent {
  render() {
    let { preview, previewing, onClose, show, previewUrl } = this.props;

    return (
      <div className={'mc-send-box-msg-edit ' + (!show ? 'mc-hide' : '')}>
        <div className={'mc-mt10'}>
          <SVGIcon iconname={BASE_ICONS.LINK} fill={variables['colors-mc-primary']} />
        </div>
        <div className={'mc-flex-5-col mc-grow'} style={{ minWidth: 1 }}>
          <div className={'mc-primary-520 mc-text-truncate'}>
            {previewing ? lang.t('Getting link info...') : preview?.title}
          </div>
          <div style={{ display: 'grid' }}>
            <div className={'mc-text-truncate'}>
              {!preview?.description ? previewUrl : preview?.description}&nbsp;
            </div>
          </div>
        </div>
        <button type={'button'} className={'mc-no-style-btn'} onClick={onClose}>
          <SVGIcon iconname={BASE_ICONS.CLOSE} width={20} />
        </button>
      </div>
    );
  }
}
